import { Injectable } from '@angular/core';
import { ApiHttpService } from './api-http.service';
import { Observable } from 'rxjs';

@Injectable()
export class UserPreferenceService {

  constructor(private apiHttp: ApiHttpService) { }

  public get = (): Observable<UserPreference> => {
    return this.apiHttp.get<UserPreference>('userpreferences');
  }
}

export interface UserPreference {
  defaultCeSite?: number;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/user-preference.service.ts